<template>
  <div class="login-container">
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      status-icon
      ref="ruleForm2"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-page"
    >
      <h3 class="title">添加用户</h3>
      <el-form-item prop="username">
        <el-input
          type="text"
          v-model="ruleForm2.username"
          auto-complete="off"
          placeholder="用户名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="email">
        <el-input
          type="text"
          v-model="ruleForm2.email"
          auto-complete="off"
          placeholder="email"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          v-model="ruleForm2.password"
          auto-complete="off"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <el-checkbox v-model="ruleForm2.is_admin" class="rememberme"
        >是否为管理账号
      </el-checkbox>
      <el-form-item style="width:100%;">
        <el-button
          type="primary"
          style="width:100%;"
          @click="RegisterSubmit"
          :loading="logining"
          >新增
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Register",
  data() {
    let checkEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入email"));
      } else {
        const reg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
        if (!reg.test(value)) {
          callback(new Error("请输入有效的Email"));
        }
        callback();
      }
    };
    return {
      logining: false,
      ruleForm2: {
        username: "",
        password: "",
        email: "",
        is_admin: false
      },
      rules2: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "用户名长度在 3 到 15 个字符",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 15,
            message: "密码长度在 6 到 15 个字符",
            trigger: "blur"
          }
        ],
        email: [{ validator: checkEmail, trigger: "blur" }]
      }
    };
  },
  methods: {
    ...mapActions("user", ["register"]),
    RegisterSubmit() {
      this.$refs.ruleForm2.validate(valid => {
        if (valid) {
          this.logining = true;
          let data = {
            user: this.ruleForm2,
            successCallback: () => {
              this.$message.success("新增用户成功");
              this.$router.push(this.redirect("index"));
            },
            errorCallback: error =>
              this.$message.error(
                `新增用户失败： ${error.response.data.message}`
              )
          };
          if (this.register(data)) {
            this.$refs.ruleForm2.resetFields();
          }
          this.logining = false;
        } else {
          this.$message.error("请检查输入是否正确");
          this.logining = false;
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100%;
}

.login-page {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  margin: 100px auto;
  width: 350px;
  padding: 35px 35px 15px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

label.el-checkbox.rememberme {
  margin: 0px 0px 15px;
  text-align: left;
}
</style>
